// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // 스타일시트 파일 (optional)
import App from './App'; // App 컴포넌트 (이 파일이 존재한다고 가정)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
